import React from 'react';
import {Text, View} from 'react-native';
import {Table} from '../../../shared/components/table';
import {Column} from '../../../shared/components/table/model';
import {useStyles} from '../../../shared/hooks/styles';
import {MoneyOperation} from '../../../shared/models/api/skipassResponsePayload';
import {useTheme} from '../../../shared/theme';
import {DeviceSize} from '../../../shared/theme/helpers';
import {formatDateTime} from '../../../shared/utils/formatDate';

interface OperationsTableProps {
  data: MoneyOperation[] | undefined;
}

export function OperationsTable({data}: OperationsTableProps) {
  const styles = useStyles(({mediaOnly, theme}) => ({
    tableContainer: {
      ...mediaOnly(DeviceSize.desktop, {width: '80%'}),
    },
    colText: {
      ...theme.fonts.body,
      color: theme.color.textColor,
    },
    textCenter: {
      textAlign: 'center',
    },
    textRight: {
      textAlign: 'right',
    },
  }));

  const theme = useTheme();

  const columns: Column<MoneyOperation>[] = [
    {
      title: 'Наименование',
      field: 'goodsName',
      headStyles: {
        colHeadStyle: {flexBasis: '60%'},
      },
      styles: {
        colBodyTextStyle: styles.colText,
        colBodyStyle: {flexBasis: '60%'},
      },
      render: (row) => {
        return (
          <Text style={styles.colText}>
            {row.comment}, {row.goodsName}
          </Text>
        );
      },
    },
    {
      title: 'Дата и время',
      field: 'timestamp',
      render: (row) => {
        return <Text style={[styles.colText, styles.textCenter]}>{formatDateTime(row.timestamp)}</Text>;
      },
      headStyles: {
        colHeadTextStyle: styles.textCenter,
        colHeadStyle: {flexBasis: '25%'},
      },
      styles: {
        colBodyStyle: {flexBasis: '25%'},
      },
    },
    {
      title: 'Стоимость',
      field: 'amount',
      render: (row) => {
        return (
          <Text
            style={[
              styles.colText,
              styles.textRight,
              row.amount < 0 && {color: theme.skipass.redColor},
              row.amount === 0 && {color: theme.skipass.neutralColor},
              row.amount > 0 && {color: theme.skipass.greenColor},
            ]}>
            {row.amount < 0 ? Math.abs(row.amount) : `+${row.amount}`} ₽
          </Text>
        );
      },
      headStyles: {
        colHeadTextStyle: styles.textRight,
        colHeadStyle: {flexBasis: '15%'},
      },
      styles: {
        colBodyStyle: {flexBasis: '15%'},
      },
    },
  ];

  return (
    <View style={styles.tableContainer}>
      <Table data={data} columns={columns} />
    </View>
  );
}
